// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.book-search-input {
  width: 200px;
  height: 35px;
  padding: 4px 12px;
  border: 2px solid #656d4a;
  border-radius: 0;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.book-search-input:focus-visible {
  outline: none !important;
}
@media (max-width: 320px) {
  .book-search-input {
    width: 180px;
  }
}

.book-search-submit {
  width: 80px;
  height: 35px;
  border: 0;
  background-color: #656d4a;
  border: 2px solid #656d4a;
  color: white;
  transform: translateX(-1px);
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
.book-search-submit--disabled {
  opacity: 0.7;
  cursor: default;
}

.too-long-warning {
  background-color: #fffaf3;
  color: #573a08;
  box-shadow: 0 0 0 1px #c9ba9b inset, 0 0 0 0 transparent;
  padding: 0.3rem;
  color: rgba(0, 0, 0, 0.87);
  width: 28rem;
  margin: 1rem auto 0;
}
.too-long-warning .icon {
  margin-right: 0.2em;
  line-height: 1;
  font-size: 1.5em;
  opacity: 0.8;
  display: inline-block;
  vertical-align: middle;
}
.too-long-warning .content {
  text-align: left;
  display: inline-block;
  vertical-align: middle;
  width: 24.5rem;
}

.able-to-search {
  display: inline-block;
  padding-bottom: 10px;
  position: relative;
}
.able-to-search:after {
  position: absolute;
  content: "";
  left: 0;
  bottom: -1px;
  width: 100%;
  height: 3px;
  background: #656d4a;
  border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Landing/Landing.scss","webpack://./src/scss/variables.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,2BAAA;EACA,8BAAA;AADF;AAGE;EACE,wBAAA;AADJ;AAIE;EAbF;IAcI,YAAA;EADF;AACF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,yBCxBU;EDyBV,yBAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,+BAAA;AADF;AAGE;EACE,YAAA;EACA,eAAA;AADJ;;AAKA;EACE,yBAAA;EACA,cAAA;EACA,wDAAA;EACA,eAAA;EACA,0BAAA;EACA,YAAA;EACA,mBAAA;AAFF;AAIE;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;AAFJ;AAKE;EACE,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,cAAA;AAHJ;;AAOA;EACE,qBAAA;EACA,oBAAA;EACA,kBAAA;AAJF;AAME;EACE,kBAAA;EACA,WAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,mBC3EQ;ED4ER,kBAAA;AAJJ","sourcesContent":["@use '../../scss/variables.scss';\n\n.book-search-input {\n  width: 200px;\n  height: 35px;\n  padding: 4px 12px;\n  border: 2px solid variables.$mainGreen;\n  border-radius: 0;\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n\n  &:focus-visible {\n    outline: none !important;\n  }\n\n  @media (max-width: 320px) {\n    width: 180px;\n  }\n}\n\n.book-search-submit {\n  width: 80px;\n  height: 35px;\n  border: 0;\n  background-color: variables.$mainGreen;\n  border: 2px solid variables.$mainGreen;\n  color: white;\n  transform: translateX(-1px);\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px;\n\n  &--disabled {\n    opacity: 0.7;\n    cursor: default;\n  }\n}\n\n.too-long-warning {\n  background-color: #fffaf3;\n  color: #573a08;\n  box-shadow: 0 0 0 1px #c9ba9b inset, 0 0 0 0 transparent;\n  padding: 0.3rem;\n  color: rgba(0, 0, 0, 0.87);\n  width: 28rem;\n  margin: 1rem auto 0;\n\n  .icon {\n    margin-right: 0.2em;\n    line-height: 1;\n    font-size: 1.5em;\n    opacity: 0.8;\n    display: inline-block;\n    vertical-align: middle;\n  }\n\n  .content {\n    text-align: left;\n    display: inline-block;\n    vertical-align: middle;\n    width: 24.5rem;\n  }\n}\n\n.able-to-search {\n  display: inline-block;\n  padding-bottom: 10px;\n  position: relative;\n\n  &:after {\n    position: absolute;\n    content: '';\n    left: 0;\n    bottom: -1px;\n    width: 100%;\n    height: 3px;\n    background: variables.$mainGreen;\n    border-radius: 8px;\n  }\n}\n","$mainGreen: #656d4a;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
